import { Button, Col, Modal, Row } from "antd";
import React, { useContext, useState } from "react";
import "../../../assets/css/commonVessels.css";
import HButton from "../../../components/custom/input/button/Button";
import { VOICE_PLUS_MESSAGING_STARTS_AT_MONTHLY } from "../../../constants/AppConstants";
import { AppContext } from "../../../context/AppContext";
import useHttp from "../../../hooks/useHttp";
import useLicense from "../../../hooks/useLicense";

const LicenseInvalidModal = () => {
    const [appProperties] = useContext(AppContext);
    const isMobileApp = navigator.userAgent.includes("HelloSendMobile");
    const isModalVisible = true;
    const [open, setOpen] = useState(false);
    const { fetchData } = useHttp();
    const { fetchStripeURL } = useLicense();
    const urlParams = new URLSearchParams(window.location.search);
    const purchased = urlParams.get("purchased");
    const handleManageSubscription = (e) => {
      if (appProperties.licenseHandledBy === "STRIPE") {
        fetchStripeURL(appProperties).then(function (stripeLink) {
          window.open(stripeLink.url, "_blank");
        });
      } else {
        appProperties.controller.pricingLink(appProperties).then(function (resp) {
          window.open(resp, "_blank");
        });
      }
    };
  
    const getLicenseDetails = () => {
      window.location.reload();
    };
  
    const handleMobileLogout = () => {
      const redirectToLogout = () => {
        window.location.href = "/logout?" + new URLSearchParams(window.location.search).toString();
      };
      fetchData("logout", "DELETE", null, appProperties)
        .then(redirectToLogout)
        .catch(redirectToLogout);
    };
  
    return (
      <>
        <div>
          <Modal
            width={400}
            className="activateLicenseModal"
            open={isModalVisible}
            footer={null}
            closable={false}
            centered
          >
            {isMobileApp ? (
              <div className="d-flex flex-column align-items-center text-center py-3 gap-3">
                <div className="staticIconsSprite licenseIcon"></div>
                <div style={{ fontSize: "16px", fontWeight: 600 }}>Access restricted.</div>
                <div style={{ fontSize: "14px" }} className="pb-2">
                  Login with an active account to continue using HelloSend.
                </div>
                <Button
                  onClick={handleMobileLogout}
                  className="fs-6 w-100"
                  size="large"
                  style={{ backgroundColor: "#F5F5F5", border: "none" }}
                >
                  Logout
                </Button>
              </div>
            ) : (
              <>
                {purchased && (
                  <Row className="hs-fw-500">
                    <span className="actionIconsSprite refresh-icon-new  " onClick={getLicenseDetails}></span> Please refresh
                    the page to stay updated
                  </Row>
                )}
                <Row>
                  <Col span={20}>
                    <div className="d-flex align-items-left justify-content-left mt-3 mb-3">
                      <div className="staticIconsSprite licenseIcon"></div>
                    </div>
                  </Col>
                </Row>
                <div style={{ fontSize: "16px", fontWeight: 600 }} className="mb-1 me-3">
                  Get access to stay connected with client replies.
                </div>
                <div className="pb-3">
                  Starts at {`${VOICE_PLUS_MESSAGING_STARTS_AT_MONTHLY}`}/month with 3 users included
                </div>
                <Row>
                  <Col span={10} className="activateExtendBtn">
                    <Button
                      onClick={() => setOpen(true)}
                      id="extendTrail"
                      className="fs-6 extendTrail w-100"
                      size="large"
                      style={{ backgroundColor: "#F5F5F5", border: "none" }}
                    >
                      <span style={{ fontSize: "14px" }}>Extend Trial</span>
                    </Button>
                  </Col>
                  <Col span={10} className="ms-4 w-100">
                    <HButton buttonClassName="hs-fs-16 px-3 w-100 d" size="l" onClick={handleManageSubscription}>
                      Get Access
                    </HButton>
                  </Col>
                </Row>
              </>
            )}
          </Modal>
  
          {open && (
            <Modal
              title=" "
              centered
              open={open}
              onOk={() => setOpen(false)}
              onCancel={() => setOpen(false)}
              width={1000}
              footer={null}
            >
              <div>
                <iframe
                  className="iframe-popup"
                  src={`https://oapps.zohobookings.com/portal-embed#/share-and-extend?Name=${appProperties?.userName}&Email=${appProperties?.currentUserEmail}`}
                  frameBorder="0"
                  allowFullScreen
                  title="Extend Trial"
                />
              </div>
            </Modal>
          )}
        </div>
      </>
    );
};

export default LicenseInvalidModal;